import React from 'react';
import { cn } from '@/lib/utils';
import { User, LayoutList, Stethoscope, Receipt, LineChart, Monitor } from 'lucide-react';

const personaConfig = {
  patient: {
    icon: User,
    label: 'Patient'
  },
  receptionist: {
    icon: LayoutList,
    label: 'Receptionist'
  },
  doctor: {
    icon: Stethoscope,
    label: 'Doctor'
  },
  billing: {
    icon: Receipt,
    label: 'Billing'
  },
  owner: {
    icon: LineChart,
    label: 'Owner'
  },
  display: {
    icon: Monitor,
    label: 'Waiting Display'
  }
};

const PersonaIcon = ({ 
  persona, 
  size = 'md',
  showLabel = false,
  className,
  ...props 
}) => {
  const config = personaConfig[persona] || personaConfig.patient;
  const Icon = config.icon;
  
  const sizeConfig = {
    sm: { container: 40, icon: 18 },
    md: { container: 48, icon: 20 },
    lg: { container: 56, icon: 24 },
    xl: { container: 64, icon: 28 }
  };
  
  const sizes = sizeConfig[size];

  return (
    <div className={cn('flex flex-col items-center gap-2', className)} data-testid={props['data-testid']}>
      <div
        className="relative rounded-full flex items-center justify-center"
        style={{
          width: `${sizes.container}px`,
          height: `${sizes.container}px`,
          background: 'linear-gradient(135deg, rgba(255,255,255,0.68) 0%, rgba(255,255,255,0.45) 100%)',
          border: '1px solid rgba(255, 255, 255, 0.75)',
          boxShadow: 'var(--shadow-sm), inset 0 1px 0 0 rgba(255, 255, 255, 0.4)'
        }}
      >
        <Icon 
          size={sizes.icon} 
          strokeWidth={1.75}
          style={{ color: 'var(--color-slate)', opacity: 0.72 }}
        />
      </div>
      {showLabel && (
        <span 
          className="font-['Sora'] text-xs font-semibold"
          style={{ color: 'var(--color-text-secondary)' }}
        >
          {config.label}
        </span>
      )}
    </div>
  );
};

PersonaIcon.displayName = 'PersonaIcon';

export { PersonaIcon };